import axios from "axios";

const API_URL = "https://supadaa.com/api/";

const authHeaders = (extra = {}) => ({
  Accept: "application/json",
  Authorization: `Bearer ${sessionStorage.getItem("token")}`,
  ...extra,
});

const json = () => authHeaders({ "Content-Type": "application/json" });

const getAll = async () => (await axios.get(`${API_URL}faqs`, { headers: authHeaders() })).data;
const create = async (data) => (await axios.post(`${API_URL}faqs/create`, data, { headers: json() })).data;
// data ma 'id' hovu joiye
const update = async (data) => (await axios.post(`${API_URL}faqs/update`, data, { headers: json() })).data;
const remove = async (id) => (await axios.post(`${API_URL}faqs/delete`, { id }, { headers: json() })).data;

export default { getAll, create, update, remove };